import React from "react";
import FilterList from "../../../components/user/moveFlows/moveFlowsFilterList";
import Layout from "../../../components/layouts/verticalLayout";

const MoveListPage = (props) => {
  return <Layout body={<FilterList />} />;
};

MoveListPage.propTypes = {};

export default MoveListPage;
